module.exports = __webpack_public_path__ + "static/img/killjoy.b75707af.png";